import axios from "axios";
import { AppConfig } from "../config";
import { isString } from "lodash";
import { setSpamDetected } from "../store/shared/spamDetected";

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  baseURL: AppConfig.apiUrl,
});

const requestStart = (request: any): any => {
  // const auth = $auth.getState();
  // if (auth.isLoggedIn) {
  //   request.headers["Authorization"] = `Bearer ${auth.token}`;
  // }
  return request;
};

const requestError = (error: any): Promise<any> => Promise.reject({ ...error });

axiosInstance.interceptors.request.use(requestStart, requestError);

const responseSuccess = (response: any): any => response;

const responseError = (error: any): any => {
  const err = Promise.reject({ ...error });
  err.catch((err) => {
    const doErr = console.log;
    if (err.response) {
      const data = err.response.data;
      if (
        err.response.status === 400 &&
        err.response.data.errors === "Unauthenticated."
      ) {
        // history.push("/login");
        return;
      }
      if (err.response.status === 401) {
        if (err.response.data.message) {
          doErr({ message: err.response.data.message });
        }
      } else if (err.response.status === 500) {
        doErr({
          message: "Server error!",
          description: err.response.data.message,
        });
      } else if (err.response.status === 429) {
        setSpamDetected(true);
      } /*else if (err.response.status === 404) {
        doErr({ message: "Not found!" });
      }*/ else if (
        err.response.data.message
      ) {
        doErr({ message: data.message });
      } else if (
        err.response.data.errors &&
        isString(err.response.data.errors)
      ) {
        doErr({ message: data.errors });
      }
    } else {
      doErr({
        message: "Some error occured!",
        description:
          "This may happen if your Internet connection is down. Or if server is brawling.",
        duration: 3,
      });
    }
  });
  return err;
};

axiosInstance.interceptors.response.use(responseSuccess, responseError);

export default axiosInstance;
